module.exports = __webpack_public_path__ + "media/images/1-8bea98f0.png";